<template>
  <v-select
    v-model="model"
    :items="data"
    :label="label"
    :loading="loading"
    clearable
    item-value="id"
    item-text="name"
    color="primary"
    placeholder="Select role"
  />
</template>

<script>
export default {
  name: "choose-role-single",
  props: ["label", "value"],
  data() {
    return {
      loading: false,
      model: this.value,
      data: [],
    };
  },
  mounted() {
    this.loadRoles();
  },
  watch: {
    model(val) {
      this.$emit("input", val ? Number.parseInt(val) : null);
    },
    value(newVal) {
      this.model = newVal;
    },
  },
  methods: {
    loadRoles() {
      this.loading = true;
      this.axios
        .get("roles", {
          params: {
            perPage: 50,
          },
        })
        .then((res) => {
          const responseData = res.data.data;
          // Handle both paginated and non-paginated responses
          this.data =
            responseData && responseData.data
              ? responseData.data
              : responseData || [];
        })
        .catch((err) => {
          console.error("Error loading roles:", err);
          window.getApp.$emit("SHOW_TOAST", "Failed to load roles", "red");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>

